var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "span",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.date,
          expression: "date",
        },
      ],
    },
    [_vm._v(_vm._s(_vm.format(_vm.date)))]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }